<template>
  <div class="import-preset">
    <GwInput
      :placeholder="$t('tooltips.import_drill')"
      style="--input-height: 2.5rem"
      type="text"
      autofocus
      :getErrors="() => (inputError ? [$t('messages.trainer_preset_import_error')] : [])"
      :value="inputValue"
      @input="(_e, value) => (inputValue = value)"
      @keydown:enter="apply(inputValue)"
    />
  </div>
</template>

<script>
import { getTrainerClearQuery, trainerMustDefaultPreset } from '@/helpers/trainer_presets'
import { getGameformatQuery, getGameformatGroup } from '@/store/gameformat/gameformat'
import { getBoardQuery, getFullHandSetupQuery, getBoardFilterQuery } from '@/store/router/router'
import format_mix from '@/mixins/format_mix'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'ImportDrill',
  components: { GwInput },
  mixins: [format_mix],
  props: {
    namespace: { String, required: true },
  },
  emits: ['success'],
  data() {
    return {
      inputValue: '',
      inputError: false,
    }
  },
  methods: {
    getName({ presets, preset }) {
      const getNameCopy = ({ names, name }) => {
        let newName = name
        const sameNames = names.filter(n => n === newName)
        const l = sameNames.length
        if (l > 0) {
          newName = `(COPY) ${newName}`
          return getNameCopy({ names, name: newName })
        }
        return newName
      }

      let selectedName = preset.name || `Nameless`
      const names = presets.map(p => p.name)
      selectedName = getNameCopy({ names, name: selectedName })
      return selectedName
    },
    async apply() {
      this.inputError = false
      try {
        const preset = JSON.parse(this.inputValue)

        const mode = getGameformatGroup(preset?.query?.gametype)
        if (!mode) {
          throw new Error('gameformat_group_not_found')
        }
        if (!this.$store.getters.gameformats_groupsSet[mode]) {
          const result = await this.$store.dispatch('get_gameformat_groups', [mode])
          if (!result || result.error) {
            throw new Error('gameformat_group_not_found')
          }
        }

        const { gameformats } = this.$store.getters

        const { drills_all } = this.$store.getters
        const name = this.getName({ presets: drills_all, preset })

        let presetQuery = preset.query || {}

        const { query: gameformatQuery } = getGameformatQuery({
          gameformats,
          lsKey: this.namespace,
          customQuery: presetQuery,
          localOnly: false,
        })

        // first empty all that might be set
        const clearPreset = {
          ...gameformatQuery,
          ...trainerMustDefaultPreset(),
          ...presetQuery,
        }
        presetQuery = getTrainerClearQuery(clearPreset)

        const checkedFullhandQuery = getFullHandSetupQuery({
          customQuery: presetQuery,
        })
        const checkedBoardhandQuery = getBoardQuery({
          customQuery: presetQuery,
        })
        const checkedBoardFilterQuery = getBoardFilterQuery({
          customQuery: presetQuery,
        })

        const query = {
          ...presetQuery,
          ...gameformatQuery,
          ...checkedFullhandQuery,
          ...checkedBoardhandQuery,
          ...checkedBoardFilterQuery,
        }
        const completePreset = {
          id: '',
          name,
          description: preset.description || '',
          query,
        }

        this.$store.dispatch('drills_set_drill', {
          items: [completePreset],
          method: 'POST',
          namespace: this.namespace,
        })

        this.showInput = false
        this.inputValue = ''
        this.$emit('success', completePreset)
      } catch (error) {
        console.log('error', error)
        this.inputError = 'invalid_json'
        this.inputValue = ''
      }
    },
  },
}
</script>

<style lang="scss">
.import-preset {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
